/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_ClientsInputs */

const cs_dashboard_kpi_clients = /** @type {(inputs: Dashboard_Kpi_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivní klienti`)
};

const en_dashboard_kpi_clients = /** @type {(inputs: Dashboard_Kpi_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active clients`)
};

/**
* | output |
* | --- |
* | "Active clients" |
*
* @param {Dashboard_Kpi_ClientsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_clients = /** @type {((inputs?: Dashboard_Kpi_ClientsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_ClientsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_kpi_clients(inputs)
	return cs_dashboard_kpi_clients(inputs)
});